import zhHans from 'vuetify/lib/locale/zh-Hans'

// Usage -> {{ t('$vuetify.close') }} -> 关闭
export default {
  ...zhHans,
  __InterfaceSetting: {
    bottom_menu: {
      title: '底部菜单',
      add_item: '添加项目',
      delete_item: '删除项目',
      change_image: '更换图片',
      payload: '触发文本'
    },
    weather: {
      title: '天气',
      select_region: '选择地区',
      hint: '选择设备上要显示哪个地区的天气。',
      hong_kong: '香港',
      taiwan: '台湾'
    },
    branding: {
      title: '品牌图片',
      description: '自定义设备上显示的背景、标志及 QR 码图片。',
      background: '背景',
      logo: '标志',
      qr: 'QR 码',
      hint: '支持格式：PNG、JPG、WEBP，文件上限 8MB。',
      using_default: '使用默认图片',
      upload: '上传',
      change: '更换',
      reset: '还原默认',
      done: '完成',
      cancel: '取消',
      upload_file: '上传文件',
      filepond_hint: '拖放图片至此或浏览…'
    }
  },
  __AI: {
    mrc: {
      sources: '来源',
      sources_desc: '上传并管理供 MRC AI 扫描的文档与网站。',
      upload_document: '上传文档',
      add_website: '新增网站',
      search_sources: '搜索来源',
      type_document: '文档',
      type_website: '网站',
      status_crawled: '已抓取',
      upload_to_other_lang_hint: '已上传至 {0}。',
      waiting_response: '等待响应中…',
      query_timeout: '请求超时，请重试。',
      export: {
        button: '导出文档列表',
        device_name: '设备名称',
        enabled: '已启用',
        disabled: '已停用'
      },
      upload_file_dialog: {
        title: '上传文档'
      },
      add_website_dialog: {
        title: '新增网站',
        url_label: '网站网址',
        url_placeholder: 'https://example.com/...',
        invalid_url: '请输入有效的网址'
      },
      batch: {
        selected: '已选取 {0} 项',
        delete: '删除',
        enable: '启用',
        disable: '停用',
        clear: '清除选取',
        confirm_delete_title: '删除 {0} 份文件？',
        confirm_delete_hint: '所选文件将被永久删除，且无法复原。',
        confirm_enable_title: '启用 {0} 份文件？',
        confirm_enable_hint: '所选文件将被启用，纳入 MRC AI 扫描。',
        confirm_disable_title: '停用 {0} 份文件？',
        confirm_disable_hint: '所选文件将被排除于 MRC AI 扫描之外。',
        success_delete: '已排入删除 {0} 份文件。',
        success_enable: '已启用 {0} 份文件。',
        success_disable: '已停用 {0} 份文件。',
        partial: '成功 {0} 项，失败 {1} 项。',
        too_many: '一次最多只能处理 {0} 份文件。'
      }
    }
  },
  __DatatableHeader: {
    file_name_or_source: '文件名 / 来源',
    type: '类型',
    enable: '启用'
  },
  __Dashboard: {
    funnel_title: 'Botisfy 使用漏斗',
    funnel_proxy_note: '* 代理值（精确数据待事件追踪上线）',
    funnel_error: '漏斗加载失败',
    opened_sessions: '开启人次',
    engaged_sessions: '互动人次',
    answered_turns: '回答轮次',
    avg_turns_per_engaged_session: '平均互动轮次',
    opened_sessions_tooltip: '用户打开 chatbot 或建立 session 的次数，可能包含只看到欢迎语、语言选择或 disclaimer，但尚未实际提问的情况。',
    engaged_sessions_tooltip: '至少有一次实际互动的 session，例如选择语言、接受 disclaimer、点击按钮或输入消息。',
    answered_turns_tooltip: 'Bot 实际回复用户问题的轮次。一般来说，一次用户提问加一次 bot 回答，计为一个回答轮次。',
    avg_turns_per_engaged_session_tooltip: '平均每个有互动的 session 产生多少轮有效问答，可用来观察用户是否持续与 chatbot 对话。'
  },
  __LeftBar: {
    search_device: '搜索设备',
    no_device_found: '找不到匹配的设备'
  }
}
